'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _emotion = require('../emotion');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withStyles(defaultStyles) {
  return function (WrappedComponent) {
    function withStylesMerge(_ref) {
      var className = _ref.className,
          overrideStyles = _ref.overrideStyles,
          props = _objectWithoutProperties(_ref, ['className', 'overrideStyles']);

      var useClassName = overrideStyles ? className : (0, _emotion.cx)(defaultStyles, className);
      return _react2.default.createElement(WrappedComponent, Object.assign({ className: useClassName }, props));
    }

    withStylesMerge.propTypes = {
      className: _propTypes2.default.string,
      overrideStyles: _propTypes2.default.bool
    };

    withStylesMerge.defaultProps = {
      className: '',
      overrideStyles: false
    };

    withStylesMerge.displayName = 'withStyles(' + getDisplayName(WrappedComponent) + ')';

    return withStylesMerge;
  };
}

exports.default = withStyles;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-styles/build/withStyles.js
// module id = 864
// module chunks = 0